import axios from 'core/api'

import { FeatureConfigResponse } from './types'

export const getFeatureConfig = (key: string) =>
  axios.get<FeatureConfigResponse>('/feature-config', { params: { key } })
